import { useMemo } from 'react'
import { NetworkTreeNode } from './types'

export const useDisabledNodes = (
  data: NetworkTreeNode[],
  checkAccessibility: boolean = false
) => {
  return useMemo(() => {
    const disabledNodeIds = new Set<string>()
    // Skip all accessibility logic if not explicitly requested
    if (!checkAccessibility || !data || data.length === 0) {
      return disabledNodeIds
    }

    // Disable nodes based on whichever accessibility field they have
    data.forEach(node => {
      const isAccessible =
        ('isLtiAccessible' in node.network && node.network.isLtiAccessible) ||
        ('isAccessible' in node.network && node.network.isAccessible)

      const isContractExpired =
        'isContractExpired' in node.network && node.network.isContractExpired

      if (!isAccessible || isContractExpired) {
        disabledNodeIds.add(node.network.id)
      }

      // viewableParent if it exists
      if (node.viewableParent) {
        const parentIsAccessible =
          ('isLtiAccessible' in node.viewableParent &&
            node.viewableParent.isLtiAccessible) ||
          ('isAccessible' in node.viewableParent &&
            node.viewableParent.isAccessible)

        const isParentContractExpired =
          'isContractExpired' in node.viewableParent &&
          node.viewableParent.isContractExpired

        if (!parentIsAccessible || isParentContractExpired) {
          disabledNodeIds.add(node.viewableParent.id)
        }
      }
    })

    return disabledNodeIds
  }, [data, checkAccessibility])
}
